export enum ProjectAIType {
  ChatGPTRegular = 0,
  ChatGPTResponsesAPI = 1,
}

export enum Environment {
  Local = 'local',
  Staging = 'staging',
  Testing = 'testing',
  Production = 'production'
}

export enum ChatMessageDirection {
  FromUs = 0,
  ToUs = 1,
}

export enum UserRole {
  SuperUser = 'SuperUser',
  ProjectOwner = 'ProjectOwner',
  CustomerSupport = 'CustomerSupport',
}

export enum InnerUrl {
  Chats = '/chats'
}

export enum UserRoleId {
  SystemUser = 1,
  SuperUser = 2,
  Administrator = 3,
  ProjectOwner = 4,
  CustomerSupport = 5
}

export enum UILanguage {
  English = 'en',
  Estonian = 'et',
  Russian = 'ru',
  Spanish = 'es'
}

export enum ProjectStatus {
  Active = 1,
  Paused = 2,
  Archived = 3
}

export enum WebsocketConnectionState {
  Disconnected = 0,
  Connected = 1,
  Connecting = 2,
}

export enum BackendErrorCode {
  UserNotFoundOrWrongPassword = 'ERR_USER_NOT_FOUND_OR_WRONG_PASSWORD',
  ErrUserAccountDeactivated = 'ERR_USER_ACCOUNT_DEACTIVATED',
  AddProjectProjectKeyExists = 'ERR_ADD_PROJECT_PROJECT_KEY_EXISTS',
  AddUserUsernameExists = 'ERR_ADD_USER_USERNAME_EXISTS',
  ProjectNotFound = 'ERR_PROJECT_NOT_FOUND',
  ProjectAccessDenied = 'ERR_PROJECT_ACCESS_DENIED',
  UnknownError = 'UNKNOWN_ERROR',
  UserUnableToRetrieveContext = 'ERR_USER_UNABLE_TO_RETRIEVE_CONTEXT',
  UserUnableToCreateNewSession = 'ERR_USER_UNABLE_TO_CREATE_NEW_SESSION',
  Unauthorized = 'ERR_UNAUTHORIZED',
  ErrChatGptAssistantNotCreated = 'ERR_CHAT_GPT_ASSISTANT_NOT_CREATED',
  Forbidden = 'ERR_FORBIDDEN',
  ChatNotFound = 'ERR_CHAT_NOT_FOUND',
  UnableClearSession = 'ERR_UNABLE_CLEAR_SESSION',
  ChatAiControlAlreadyTaken = 'ERR_CHAT_AI_CONTROL_ALREADY_TAKEN',
  ChatAiUnableToTakeControl = 'ERR_CHAT_AI_UNABLE_TO_TAKE_CONTROL',
  DatabaseError = 'ERR_DATABASE_ERROR',
  IncorrectFileType = 'ERR_INCORRECT_FILE_TYPE',
  UnableToProcessFile = 'ERR_UNABLE_TO_PROCESS_FILE',
  FileSizeTooLarge = 'ERR_FILE_SIZE_TOO_LARGE',
  MaxFilesAmountExceeded = 'ERR_MAX_FILES_AMOUNT_EXCEEDED',
  IncorrectFileNaming = 'ERR_INCORRECT_FILE_NAMING',
  UnableUploadFileToOpenAI = 'ERR_UNABLE_UPLOAD_FILE_TO_OPEN_AI',
  AiTypeNotSupported = 'ERR_AI_TYPE_NOT_SUPPORTED',
  ChatGptAssistantNotCreated = 'ERR_CHAT_GPT_ASSISTANT_NOT_CREATED',
  ChatGptUnableToRetrieveAssistant = 'ERR_CHAT_GPT_UNABLE_TO_RETRIEVE_ASSISTANT',
  NotFound = 'NOT_FOUND',
  GenericError = 'GENERIC_ERROR',
  UsernameExists                      = 'ERR_USERNAME_EXISTS',
  UserEmailExists                     = 'ERR_USER_EMAIL_EXISTS',
  UserFailedToHashPassword            = 'ERR_USER_FAILED_TO_HASH_PASSWORD'
}

export enum ErrorName {
  ProjectNotFound = 'project-not-found',
  UserNotFound = 'user-not-found',
  NotFound = 'not-found',
}

export enum ChatEvent {
  Customer = 'MESSAGE_FROM_CUSTOMER',
  AI = 'MESSAGE_TO_CUSTOMER_FROM_AI',
  CustomerSupport = 'MESSAGE_TO_CUSTOMER_FROM_CS',
  ControlHasBeenInterceptedByCustomerSupport = 'CONTROL_HAS_BEEN_INTERCEPTED_BY_CS',
}

export enum WidgetVisualPosition {
  Left = 'left',
  Right = 'right',
}

export enum PostMessageType {
  CROWDY_UPDATE_VISUAL_SETTINGS = 'CROWDY_UPDATE_VISUAL_SETTINGS',
  CROWDY_UPDATE_LOCALIZATION = 'CROWDY_UPDATE_LOCALIZATION',
}

export enum WidgetLocale {
  EN = 'en',
  ET = 'et',
  RU = 'ru',
  ES = 'es'
}

export enum ProvideElement {
  ProjectSettingsForm = 'ProjectSettingsForm',
  ProjectSettingsFormSettings = 'ProjectSettingsFormSettings',
  SubscriptionCustomerConnectionStatus = 'ProjectSettingsFormSettings',
}

export enum ProjectSettingsCategory {
  WidgetAssistantBehaviour = 'widgetAssistantBehaviour',
  WidgetLocalization = 'widgetLocalization',
  WidgetVisual = 'widgetVisual',
  Security = 'security',
  Ai = 'ai'
}

export enum ProjectSettingsField {
  //
  // ProjectSettingsCategory.WidgetVisual
  AiType = 'ai.type',
  AiChatGptInitialTask = 'ai.chatGptInitialTask',
  AiChatGptModel = 'ai.chatGptModel',
  AiChatGptAssistantName = 'ai.chatGptAssistant.name',
  AiChatGptAssistantModel = 'ai.chatGptAssistant.model',
  AiChatGptAssistantInstructions = 'ai.chatGptAssistant.instructions',
  AiChatGptAssistantTemperature = 'ai.chatGptAssistant.temperature',
  AiaChatGptAssistantTopP= 'ai.chatGptAssistant.topP',
  // Porject
  WidgetVisualHorizontalPx = 'widgetVisual.margins.horizontalPx',
  WidgetVisualVerticalPx = 'widgetVisual.margins.verticalPx',
  WidgetVisualDegree = 'widgetVisual.gradients.degree',
  WidgetVisualEnabled = 'widgetVisual.gradients.enabled',
  WidgetVisualGradientColors = 'widgetVisual.gradients.colors',
  WidgetVisualColor = 'widgetVisual.color',
  WidgetVisualAvatarUrl = 'widgetVisual.avatarUrl',
  // ProjectSettingsCategory.Common
  ChatAliveForXMinutes = 'common.chatAliveForXMinutes',
  // ProjectSettingsCategory.WidgetAssistantBehaviour
  InitialMessageTypingDelayMs = 'widgetAssistantBehaviour.initialMessageTypingDelayMs',
  InitialMessageSendingDelayAfterTypingEndedMs = 'widgetAssistantBehaviour.initialMessageSendingDelayAfterTypingEndedMs',
  DelayBeforeResponseMs = 'widgetAssistantBehaviour.delayBeforeResponseMs',
  // ProjectSettingsCategory.Security 1
  MaxMessagesPerTimeMessages = 'security.maxMessagesPerTimeMessages',
  MaxMessagesPerTimeSeconds = 'security.maxMessagesPerTimeSeconds',
  // ProjectSettingsCategory.Security 2
  MaxChatsPerTimeChats = 'security.maxChatsPerTimeChats',
  MaxChatsPerTimeSeconds = 'security.maxChatsPerTimeSeconds',
  // ProjectSettingsCategory.Security 3
  BanIpChatsLimitChats = 'security.banIpChatsLimitChats',
  BanIpChatsLimitIntervalSeconds = 'security.banIpChatsLimitIntervalSeconds',
  BanIpChatsLimitIntervalBanTimeMinutes = 'security.banIpChatsLimitIntervalBanTimeMinutes',
  // ProjectSettingsCategory.Security 4
  MaxChatMessagesPerTimeSeconds = 'security.maxChatMessagesPerTimeSeconds',
  MaxChatMessagesPerTimeMessages = 'security.maxChatMessagesPerTimeMessages',
  MaxChatMessagesPerTimeBanMinutes = 'security.maxChatMessagesPerTimeBanMinutes',
  // ProjectSettingsCategory.Security 5
  AiQuitMessagesThreshold = 'security.aiQuitMessagesThreshold'
}
